import { useState } from 'react'

import InputsWithValidate from 'Components/UI/Molecules/InputsWithValidate'
import { editWafers } from 'Components/Validation/Settings/Various/Wafers'
import { Form, Formik } from 'formik'

const UpdateForm = (props) => {
  const { concept, formRef, tipoOblea, setSelectedConcept } = props

  const APLICA_A = [
    {
      id: 'APC',
      tipo: 'APC',
    },
    {
      id: 'C',
      tipo: 'C',
    },
  ]

  const CONTROL = [
    {
      id: 0,
      tipo: 'NO',
    },
    {
      id: 1,
      tipo: 'SI',
    },
  ]

  const [data, setData] = useState({
    oblea_tipo: concept ? concept.oblea_tipo : null,
    oblea_rudac: concept ? concept.oblea_rudac : '',
    id: concept ? concept.id : '',
    familia: concept ? concept.familia : null,
    old_id: concept ? concept.old_id : null,
    codigo: concept ? concept.codigo : null,
    aplica_a: concept ? concept.aplica_a : null,
    requiere_control: concept ? concept.requiere_control : null,
  })

  const FormEdit = (values, setFieldValue) => {
    return [
      {
        class: 'textfield',
        label: 'Nombre',
        name: 'oblea_rudac',
        value: values.oblea_rudac,
        disabled: true,
        sm: 12,
        xs: 12,
      },
      {
        class: 'textfield',
        label: 'Código',
        name: 'codigo',
        value: values.codigo,
        sm: 12,
        xs: 12,
        type: 'number',
      },
      {
        class: 'autocomplete',
        options: APLICA_A,
        name: 'aplica_a',
        label: 'Aplica a',
        optionLabel: `options["tipo"]`,
        optionValue: 'tipo',
        defaultValue: APLICA_A.find((v) => v.tipo === values.aplica_a),
        sm: 12,
        xs: 12,
      },
      {
        label: 'Tipo de oblea',
        name: 'oblea_tipo',
        options: tipoOblea,
        onChange: (oblea_tipo) => {
          setFieldValue('oblea_tipo', oblea_tipo.id)
          setData({
            ...data,
            oblea_tipo: oblea_tipo.id,
          })
          setSelectedConcept({
            ...data,
            oblea_tipo: oblea_tipo.id,
          })
        },
        value: data.oblea_tipo,
        optionLabel: `options["tipo"]`,
        optionValue: 'id',
        sm: 12,
        xs: 12,
        class: 'autocomplete',
      },
      {
        class: 'autocomplete',
        sm: 12,
        xs: 12,
        options: CONTROL,
        name: 'requiere_control',
        label: 'Requiere control',
        optionLabel: `options["tipo"]`,
        optionValue: 'id',
        defaultValue: CONTROL.find((v) => v.id === values.requiere_control),
      },
      {
        class: 'autocomplete',
        sm: 12,
        xs: 12,
        options: (concept?.productos_asociados || []).map((prod) => ({
          ...prod,
          disabled: true,
        })),
        name: 'productos_asociados',
        label: 'Productos asociados',
        optionLabel: `options["producto"]`,
        optionValue: 'id',
        getOptionDisabled: (option) => option.disabled === true,
      },
    ]
  }

  const onSubmit = (data) => {
    props.onSubmit(data)
  }

  return (
    <Formik onSubmit={onSubmit} initialValues={data} validationSchema={editWafers}>
      {({ setFieldValue, values }) => (
        <Form>
          <InputsWithValidate
            fields={FormEdit(values, setFieldValue)}
            spacing={2}
            setFieldValue={setFieldValue}
            isSubmitting={false}
          />

          <button style={{ display: 'none' }} type="submit" ref={formRef} />
        </Form>
      )}
    </Formik>
  )
}

export default UpdateForm
